import { IconDefinition, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { FunctionComponent, isValidElement, memo } from "react";

import { IProps } from "./button.types";

/**
 * Theme0able button with an icon.
 * Render a button that is coloured to suit the client.
 * @returns Button element.
 */
const Button: FunctionComponent<IProps> = ({
    children,
    className,
    icon,
    isIconOnly,
    isLoading = false,
    isSmall = false,
    isUnstyled,
    outline = false,
    size,
    styleName,
    duotone = false,
    ...otherProps
}) => {
    return (
        <button
            className={classNames(className, {
                button: !isUnstyled,
                "button--outline": outline || isLoading,
                "button--duotone": duotone || isLoading,
                "button--icon": !isUnstyled && (isIconOnly === true || typeof children === "undefined"),
                "button--small": isSmall,
                [`button--${styleName}`]: typeof styleName === "string",
                [`button--${size}`]: typeof size === "string",
            })}
            disabled={isLoading}
            {...otherProps}
        >
            {typeof icon !== "undefined" && (
                <>
                    {isValidElement(icon) ? (
                        icon
                    ) : (
                        <FontAwesomeIcon
                            fixedWidth={typeof isLoading !== "undefined"}
                            icon={isLoading ? faSpinner : (icon as IconDefinition)}
                            spin={isLoading}
                            aria-label="button-icon"
                        />
                    )}
                </>
            )}
            {children && children}
        </button>
    );
};

export default memo(Button);
